import { brToNl } from "./parsing";

export const eventSteps = [
  {
    label: 'Edit Referral Campaign',
    active: true,
    completed: false,
  },
  {
    label: 'Omnichannel Preview',
    active: false,
    completed: false,
  },
  {
    label: 'Schedule Invite',
    active: false,
    completed: false,
  },
]

export const getSteps = (step) => {
  eventSteps[step].active = true;
  return eventSteps;
}

export const updateStepper = (completed, id, isSchedule) => {
  let steps = [];
  eventSteps.forEach((step, i) => {
    if (i === completed) {
      step.active = true;
    }
    else {
      step.active = false
    };

    if (id && isSchedule) {
      step.completed = true;
    } else if (id && i !== 2) {
      step.completed = true
    } else {
      step.completed = false;
    }
    steps.push(step)
  })

  return steps;
}


export const readImage = (url, callback) => {
  var request = new
    XMLHttpRequest(); request.onload = function () {
      var file = new FileReader();
      file.onloadend = function () {
        callback(file.result);
      }
      file.readAsDataURL(request.response);
    };
  request.open('GET', url);
  request.responseType = 'blob';
  request.send();
}

export const parseBody = (text) => {
  var newL = /\n/g;
  return text.replace(newL, '<br/>');
}

export const hasPendingChanges = (values, draftEvent) => {
  const keys = ["message", "startAt", "endAt", "title", "address", "additionalGuestAllowed", "ctaText", "maxAdditionalGuests", "maxNoOfGuests", "messageTitle", "placeName", "rsvpedCount"]
  for (let i = 0; i < keys.length; i++) {
    if (keys[i] === "startAt" || keys[i] === "endAt") {
      let d1 = new Date(values[keys[i]]).toString();
      let d2 = new Date(draftEvent[keys[i]]).toString();
      if (d1 !== d2) return true
    }
    else if (keys[i] === "message") {
      let m1 = brToNl(values[keys[i]], true);
      let m2 = draftEvent[keys[i]];

      if (m1 !== m2) return true
    }
    else if (values[keys[i]] && draftEvent[keys[i]] && values[keys[i]] != draftEvent[keys[i]]) {
      return true
    }
  }
  return false;
}